import React from 'react';
import {NavLink} from 'react-router-dom';
import caretSVG from '../assets/caret.svg';
import logoSVG from '../assets/logo.svg';

function Header() {
  const [click, setClick] = React.useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  
  return (
    <div>
     <div className={click ? "main-container" : ""}  onClick={()=>Close()} />
      <nav className="navbar" onClick={e => e.stopPropagation()}>
        <div className="nav-container">
          <NavLink exact to="/" className="nav-logo">
            <img className='logo-svg' src={logoSVG} alt={'logo'} />
            <span className='blue'>Box</span>Willet
          </NavLink>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <div className='menu-list'>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet/transfer"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Transfer
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet/top-up"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Top up
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet/activity"
                  activeClassName="active"
                  className="nav-links"
                onClick={click ? handleClick : null}
                >
                  Activity
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet/settings"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Settings
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/wallet/discover"
                  activeClassName="active"
                  className="nav-links"
                  onClick={click ? handleClick : null}
                >
                  Discover
                </NavLink>
              </li>
            </div>
            <div className='nav-right'>
              <div className='language'>
                <p>English</p>
                <img className="black-svg" src={caretSVG} alt='svg' />
              </div>
              <div className='user'>
              <p>EVA GREEN</p>
              <img className="black-svg" src={caretSVG} alt='svg' />
              </div>
            </div>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>
        </div>
      </nav>
    </ div>
  );
}

export default Header;
